import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CardMedia, Grid, Typography, Box } from '@mui/material';

const sampleAdverts = [
  {
    advert_id: 1,
    name: 'ISO 14001: Environmental Management System (EMS) Training',
    course_id: 6,
    image: './adverts/poster (5).png',
  },
  {
    advert_id: 2,
    name: 'ISO 45001: Occupational Health & Safety Management System (OHSMS) Training',
    course_id: 7,
    image: './adverts/poster (2).png',
  },
  {
    advert_id: 3,
    name: 'ISO/IEC 27001: Information Security Management System (ISMS) Training',
    course_id: 8,
    image: './adverts/poster (3).png',
  },
  {
    advert_id: 4,
    name: 'ISO 22000: Food Safety Management System (FSMS) Training',
    course_id: 9,
    image: './adverts/poster (4).png',
  },
];

const AdvertCards = ({ user }) => {
  const navigate = useNavigate();

  const handleCardClick = (course_id) => {
    navigate(`/courses/${course_id}/chapters`, { state: { user } });
  };

  return (
    <Box sx={{ flexGrow: 1, padding: 3 }}>
      <Grid container spacing={3} justifyContent="center">
        {sampleAdverts.map((advert) => (
          <Grid item xs={12} sm={6} md={4} key={advert.advert_id}>
            <Box
              onClick={() => handleCardClick(advert.course_id)}
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 4,
                height: 240,
                boxShadow: 3,
                cursor: 'pointer',
                '&:hover .image': {
                  transform: 'scale(1.1)',
                },
                '&:hover .overlay': {
                  opacity: 1,
                },
              }}
            >
              <CardMedia
                component="img"
                image={advert.image}
                alt={advert.name}
                className="image"
                sx={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.5s ease',
                }}
              />

              <Box
                className="overlay"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0))',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                  p: 2,
                  opacity: 0,
                  transition: 'opacity 0.4s ease',
                }}
              >
                <Typography variant="h6" color="#fff" fontWeight="bold" textAlign="center">
                  {advert.name}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdvertCards;
